var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClimateActiveSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24,18c-0.8066406,0-1.5107422-0.0732422-2.0947266-0.1821289C26.5107422,16.9257812,30,12.8623047,30,8 c0-3.3085938-2.6914062-6-6-6s-6,2.6914062-6,6c0,0.8071289-0.0732422,1.5112305-0.1826172,2.0942383 C16.9257812,5.4887695,12.8623047,2,8,2C4.6914062,2,2,4.6914062,2,8s2.6914062,6,6,6 c0.8066406,0,1.5107422,0.0732422,2.0947266,0.1821289C5.4892578,15.0742188,2,19.1376953,2,24c0,3.3085938,2.6914062,6,6,6 s6-2.6914062,6-6c0-0.8071289,0.0732422-1.5112305,0.1826172-2.0942383C15.0742188,26.5112305,19.1376953,30,24,30 c3.3085938,0,6-2.6914062,6-6S27.3085938,18,24,18z M24,28c-4.4111328,0-8-3.5888672-8-8v-1c0-0.5522461-0.4472656-1-1-1 c-2.2119141,0-3,3.0996094-3,6c0,2.2055664-1.7939453,4-4,4s-4-1.7944336-4-4c0-4.4111328,3.5888672-8,8-8h1 c0.5527344,0,1-0.4477539,1-1c0-2.2119141-3.0996094-3-6-3c-2.2060547,0-4-1.7944336-4-4s1.7939453-4,4-4 c4.4111328,0,8,3.5888672,8,8v1c0,0.5522461,0.4472656,1,1,1c2.2119141,0,3-3.0996094,3-6c0-2.2055664,1.7939453-4,4-4 s4,1.7944336,4,4c0,4.4111328-3.5888672,8-8,8h-1c-0.5527344,0-1,0.4477539-1,1c0,2.2119141,3.0996094,3,6,3 c2.2060547,0,4,1.7944336,4,4S26.2060547,28,24,28z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClimateActiveSmall);
export default __webpack_public_path__ + "static/media/climate-active--small.eed480f32bf692ecfacea6c5ed798e6e.svg";
export { ForwardRef as ReactComponent };